/**
 * Pull every fenced code block out of a markdown string.
 * Recognizes ```lang\n...\n``` blocks. Ignores tilde fences and inline backticks.
 *
 * @param {string} markdown
 * @returns {Array<{ code: string, lang: string }>}
 */
export const extractAllCodeBlocks = (markdown) => {
    if (!markdown || typeof markdown !== "string") return [];

    const blocks = [];
    const fence = /```([\w+-]*)\s*\n([\s\S]*?)```/g;
    let m;
    while ((m = fence.exec(markdown)) !== null) {
        blocks.push({
            lang: (m[1] || "").trim().toLowerCase(),
            code: m[2].replace(/\s+$/, ""),
        });
    }
    return blocks;
};

/**
 * Return the first usable code block from a markdown string.
 * If preferredLang is provided, prefer the first block whose language tag matches.
 * Falls back to the first fenced block regardless of language.
 *
 * @param {string} markdown
 * @param {string} [preferredLang]
 * @returns {{ code: string, lang: string } | null}
 */
export const extractFirstCodeBlock = (markdown, preferredLang) => {
    const blocks = extractAllCodeBlocks(markdown);
    if (blocks.length === 0) return null;

    if (preferredLang) {
        const target = preferredLang.toLowerCase();
        const match = blocks.find((b) => b.lang === target);
        if (match) return match;
    }

    return blocks[0];
};
